import { FormErrors } from "redux-form";

import { SubscriptionFormValues } from "./components/SubscriptionForm";

// Select options not checked for changes; not important on client, leave to server
function validate(formValues: SubscriptionFormValues) {
  const errors: FormErrors<SubscriptionFormValues> = {};

  const genRequiredMsg = () => "Cần thiết";

  if (!formValues.email) {
    errors.email = genRequiredMsg();
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/subscription-form-validation.ts